export {
	useAnchorPositionAtPoint,
	type TAnchorPoint,
} from '../internal/use-anchor-position-at-point';
